import { useRef, useEffect } from 'react';
import AboutLogosRow from '../../components/pages/about/AboutLogosRow';
import { Box, Typography, Container } from '@mui/material';
import SEO from '../../components/SEO';
const OctopusSyncPage = ({ setRefs }) => {
  const octopusSyncRef = useRef(null);
  const aboutRef = useRef(null);
  const featuresRef = useRef(null);
  const comparisonRef = useRef(null);
  const pricingRef = useRef(null);
  const goalsRef = useRef(null);
  const faqRef = useRef(null);

  useEffect(() => {
    setRefs({ 
      octopussync: octopusSyncRef,
      about: aboutRef,
      features: featuresRef,
      comparison: comparisonRef,
      pricing: pricingRef,
      goals: goalsRef,
      faq: faqRef
    });
  }, [setRefs]);

  return (
    <>
      <SEO
        title="OctopusSync"
        description="OctopusSync - Synchronize your digital future with seamless integration solutions."
        keywords="octopus, sync, integration, automation, business"
      />
      
      <Box ref={octopusSyncRef} id="octopussync" sx={{ minHeight: '100vh', pt: 8, position: 'relative' }}>
        <Container maxWidth="lg">
          <Typography variant="h1" sx={{ mb: 4 }}>
            OctopusSync
          </Typography>
          
          {/* About Section */}
          <Box ref={aboutRef} id="about" sx={{ minHeight: '80vh', py: 8 }}>
            <Typography variant="h2" sx={{ mb: 4 }}>
              About
            </Typography>
            <Typography variant="body1" sx={{ mb: 4 }}>
              OctopusSync is a revolutionary platform designed to synchronize your trading operations 
              across multiple exchanges and platforms. Our advanced technology ensures seamless 
              integration and real-time data synchronization for optimal trading performance.
            </Typography>
            <Typography variant="body1">
              Built with cutting-edge algorithms and secure protocols, OctopusSync empowers traders 
              and institutions to manage their portfolios with unprecedented efficiency and reliability.
            </Typography>
            <AboutLogosRow />
          </Box>
          
          {/* Features Section */}
          <Box ref={featuresRef} id="features" sx={{ minHeight: '80vh', py: 8 }}>
            <Typography variant="h2" sx={{ mb: 4 }}>
              Features
            </Typography>
            <Typography variant="body1">
              Features content will go here...
            </Typography>
          </Box>
          
          {/* Comparison Section */}
          <Box ref={comparisonRef} id="comparison" sx={{ minHeight: '80vh', py: 8 }}>
            <Typography variant="h2" sx={{ mb: 4 }}>
              Comparison
            </Typography>
            <Typography variant="body1">
              Comparison content will go here...
            </Typography>
          </Box>
          
          {/* Pricing Section */}
          <Box ref={pricingRef} id="pricing" sx={{ minHeight: '80vh', py: 8 }}>
            <Typography variant="h2" sx={{ mb: 4 }}>
              Pricing
            </Typography>
            <Typography variant="body1">
              Pricing content will go here...
            </Typography>
          </Box>
          
          {/* Goals Section */}
          <Box ref={goalsRef} id="goals" sx={{ minHeight: '80vh', py: 8 }}>
            <Typography variant="h2" sx={{ mb: 4 }}>
              Goals
            </Typography>
            <Typography variant="body1">
              Goals content will go here...
            </Typography>
          </Box>
          
          {/* FAQ Section */}
          <Box ref={faqRef} id="faq" sx={{ minHeight: '80vh', py: 8 }}>
            <Typography variant="h2" sx={{ mb: 4 }}>
              FAQ
            </Typography>
            <Typography variant="body1">
              FAQ content will go here...
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default OctopusSyncPage;
